export default {
  name: 'TheFooter',
}
